import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEn from './en.json';
import translationsEl from './el.json';
import translationsDe from './de.json';
import translationsSr from './sr.json';
import translationsRo from './ro.json';
import translationsFr from './fr.json';
import translationsIt from './it.json';
import translationsBg from './bg.json';
import translationsMk from './mk.json';
import translationsRu from './ru.json';
import translationsUk from './uk.json';
import { DEFAULT_LOCALE, supportedLocales } from './languages';

i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: supportedLocales,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: translationsEn,
    },
    el: {
      translation: translationsEl,
    },
    de: {
      translation: translationsDe,
    },
    sr: {
      translation: translationsSr,
    },
    ro: {
      translation: translationsRo,
    },
    fr: {
      translation: translationsFr,
    },
    it: {
      translation: translationsIt,
    },
    bg: {
      translation: translationsBg,
    },
    mk: {
      translation: translationsMk,
    },
    ru: {
      translation: translationsRu,
    },
    uk: {
      translation: translationsUk,
    },
  },
});

export default i18n;
